import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { allMyApplicationsQueryOptions } from "@/features/applications/queries";
import { MemberCompaniesPage } from "@/features/companies/companies-page";
import { companiesListQueryOptions } from "@/features/companies/queries";

const searchSchema = z.object({
  q: z.string().optional(),
  /** 企業選択フィルタ（カンマ区切りの企業名）。 */
  organizationNames: z.string().max(2000).optional(),
  /**
   * 業界フィルタ（カンマ区切り。企業が属する業界 `Organization.industries`）。
   * 案件一覧の `industries`（案件の業界）とは別物だが、ルートが違うので衝突しない。
   */
  industries: z.string().max(500).optional(),
  /** 自分の応募状況によるフィルタ。"all"(既定) / "applied"(応募済み) / "not-applied"(未応募) */
  applied: z.enum(["all", "applied", "not-applied"]).default("all"),
  /** 表示形式。グリッド(カード) / テーブル。案件一覧と同様に URL 管理する。 */
  view: z.enum(["grid", "table"]).default("grid"),
});

export const Route = createFileRoute("/_authenticated/member/companies/")({
  validateSearch: searchSchema,
  // ロールガードは親 layout (`member/route.tsx`) が MEMBER 限定。
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(companiesListQueryOptions()),
      context.queryClient.ensureQueryData(allMyApplicationsQueryOptions()),
    ]);
  },
  component: MemberCompaniesPage,
});
